// Mock data for the /library Contracts-tab demo (no backend). Each row is shaped
// like the eventual `idwell-api/.../contracts/filter/` list item; the demo's
// `useContractsMockTable` serves these with client-side filter / sort / paginate.

import {
  DWELLER_USER_ROLE,
  LANDLORD_USER_ROLE,
  USER_STATUS_CODE_ACTIVE,
} from '../../../../constants/user'

const AVATAR_COLORS = ['#C9DC98', '#9DC3E6', '#F4B183', '#D5A6BD', '#A9D18E']

function toMockUser({ fullname, id, role }) {
  return {
    avatar: null,
    avatar_color: AVATAR_COLORS[id % AVATAR_COLORS.length],
    email: `${fullname.toLowerCase().replace(/\s+/g, '.')}@example.com`,
    fullname,
    id,
    is_system: false,
    role,
    status: USER_STATUS_CODE_ACTIVE,
  }
}

const LANDLORDS = [
  toMockUser({ fullname: 'Anna Berger', id: 901, role: LANDLORD_USER_ROLE }),
  toMockUser({ fullname: 'Lukas Hofer', id: 902, role: LANDLORD_USER_ROLE }),
  toMockUser({ fullname: 'Marie Wagner', id: 903, role: LANDLORD_USER_ROLE }),
]

const TENANTS = [
  toMockUser({ fullname: 'Felix Gruber', id: 801, role: DWELLER_USER_ROLE }),
  toMockUser({ fullname: 'Sophie Maier', id: 802, role: DWELLER_USER_ROLE }),
  toMockUser({ fullname: 'Jonas Steiner', id: 803, role: DWELLER_USER_ROLE }),
]

const CATEGORIES = ['Residential', 'Commercial', 'Parking', 'Storage']
const HEAT_TYPES = ['District heating', 'Gas', 'Heat pump', 'Electric']
const FLOORS = [0, 1, 2, 3, 4, 5]

function pad(value) {
  return String(value).padStart(2, '0')
}

// Deterministic date builder (no Date.now — keeps the mock stable across renders).
function toIsoDate(year, month, day) {
  return `${year}-${pad(month)}-${pad(day)}`
}

const MOCK_CONTRACTS_COUNT = 20

export const MOCK_CONTRACTS = Array.from(
  { length: MOCK_CONTRACTS_COUNT },
  (_, index) => {
    const startDay = ((index + 1) % 28) + 1
    const startMonth = ((index + 5) % 12) + 1
    const startYear = 2021 + (index % 3)
    const endYear = startYear + 2

    const isArchived = index >= MOCK_CONTRACTS_COUNT - 1

    return {
      archived: isArchived,
      area: 60 + index * 2.5,
      building: {
        id: 500 + index,
        title: `Hauptstraße ${10 + index}`,
      },
      category: { value: CATEGORIES[index % CATEGORIES.length] },
      contract_id: `${465 + index}/RN s${41 + index}`,
      delayed_date: toIsoDate(endYear, ((startMonth + 2) % 12) + 1, startDay),
      duration: 24,
      dwellers: TENANTS.slice(0, (index % TENANTS.length) + 1),
      end_date: toIsoDate(endYear, startMonth, startDay),
      entrance_address: index % 3 === 0 ? `Seitenstraße ${index + 1}` : null,
      flat: {
        id: 700 + index,
        number: `${10 + index}${'abcdefghij'[index % 10]}`,
      },
      floor: FLOORS[index % FLOORS.length],
      heat_type: HEAT_TYPES[index % HEAT_TYPES.length],
      id: index + 1,
      landlords: LANDLORDS.slice(0, (index % LANDLORDS.length) + 1),
      live_area: 50 + index * 2,
      permissions: { can_archive: true, can_edit: true },
      property_share:
        index % 2 === 0 ? { share: (index % 3) + 1, total: 3 } : null,
      purchase_contract_number: `${659 + index}/RN s${53 + index}`,
      room_count: (index % 5) + 1,
      start_date: toIsoDate(startYear, startMonth, startDay),
      updated: `${toIsoDate(2024, 6, ((index + 1) % 28) + 1)}T10:00:00Z`,
    }
  }
)

export const MOCK_CONTRACTS_PERMISSIONS = {
  can_archive: true,
  can_create: true,
  can_edit: true,
}
